import { AuthorisedDevices } from "../AuthorisedDevices";
import { IAuthorisedDevices } from "../interfaces/IAuthorisedDevices";

export const authorisedDevices: IAuthorisedDevices = new AuthorisedDevices();
